import { useState } from "react";

const TruncateText = ({ res, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const text = res?.description || "";

  const shouldTruncate = text.length > maxLength;
  const displayText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <span className="truncate-text">
      {displayText}
      {shouldTruncate && !isExpanded && " ....... "}
      {shouldTruncate && (
        <button
          className="see-more-btn"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
        >
          {isExpanded ? "See Less" : "Read More"}
        </button>
      )}
    </span>
  );
};

export default TruncateText;
